
import { defineComponent, PropType } from 'vue';
import {
  ActivityIndicator,
  AjaxHelper,
  Matomo,
  translate,
} from 'CoreHome';
import Multiselect from 'vue-multiselect';
import { Group } from './TabManageGroups.vue';

export default defineComponent({
  components: {
    ActivityIndicator,
    Multiselect,
  },
  data() {
    return {
      members: [] as string[],
      logins: [] as string[],
      selectedLoginToAdd: '',
      confirmRemoveMemberText: '',
      isLoadingMembers: false,
      isLoadingLogins: false,
      isAddingMember: false,
      isRemovingMember: false,
    };
  },
  props: {
    group: {
      type: Object as PropType<Group>,
      required: true,
    },
  },
  mounted() {
    this.loadGroupMembers();
    this.loadLogins();
  },
  methods: {
    loadGroupMembers() {
      this.isLoadingMembers = true;

      AjaxHelper.post({
        module: 'API',
        format: 'json',
        method: 'GroupPermissions.getMembersOfGroup',
      }, {
        idGroup: this.group.idGroup,
      },
      {
        errorElement: '#ajaxErrorLoadMembers',
      }).then((response) => {
        this.members = response.reduce((acc: string[], member: { login: string }) => {
          acc.push(member.login);
          return acc;
        }, []);
        this.members.sort();
      }).finally(() => {
        this.isLoadingMembers = false;
      });
    },
    loadLogins() {
      this.isLoadingLogins = true;

      AjaxHelper.post({
        module: 'API',
        format: 'json',
        method: 'UsersManager.getUsersLogin',
      }, {
        filter_limit: -1,
      },
      {
        errorElement: '#ajaxErrorLoadLogins',
      }).then((response) => {
        this.logins = response;
        this.logins.sort();
      }).finally(() => {
        this.isLoadingLogins = false;
      });
    },
    addMember() {
      this.isAddingMember = true;

      const loginToAdd = this.selectedLoginToAdd;
      AjaxHelper.post({
        module: 'API',
        format: 'json',
        method: 'GroupPermissions.addUserToGroup',
      }, {
        idGroup: this.group.idGroup,
        login: loginToAdd,
      },
      {
        errorElement: '#ajaxErrorAddMember',
      }).then(() => {
        this.members.push(loginToAdd);
        this.members.sort();
      }).finally(() => {
        this.isAddingMember = false;
      });
    },
    confirmRemoveMember(member: string) {
      this.confirmRemoveMemberText = translate('GroupPermissions_RemoveFromGroupConfirm', member, this.group.name);
      Matomo.helper.modalConfirm('#confirmRemoveMember', {
        yes: () => this.removeMember(member),
      });
    },
    removeMember(member: string) {
      this.isRemovingMember = true;
      AjaxHelper.post({
        module: 'API',
        format: 'json',
        method: 'GroupPermissions.removeUserFromGroup',
      }, {
        idGroup: this.group.idGroup,
        login: member,
      },
      {
        errorElement: '#ajaxErrorManageGroupMembers',
      }).then(() => {
        this.members = this.members.filter((login) => login !== member);
      }).finally(() => {
        this.isRemovingMember = false;
      });
    },
  },
  watch: {
    group() {
      this.loadGroupMembers();
    },
  },
});
